export default __webpack_public_path__ + "static/media/card-smile-icon.caaa040f.svg";